// dependencies
import { List } from "immutable";
import React from "react";
import { connect } from "react-redux";

import DocumentPicker from "../../../../components.smart/Modals/Documents";
import Spinner from "../../../../components/Spinner";
import EditSignatureTemplate from "../components/EditSignatureTemplate";
// components
import Todo from "../components/Todo";

// actions
import {
	addTodoTemplate,
	attachDocumentToTodo,
	changeSignatureStep,
	closeDocumentPicker,
	closeSignatureTemplateEditor,
	fetchWorkflowTemplate,
	openDocumentPicker,
	openEditSignatureTemplateModal,
	removeTodo,
	reorderTodos,
	todoValueChange,
} from "../actions";

import { getAppHeight, getAppWidth } from "../../../../selectors/app";
// selectors
import { getIsRequesting } from "../../../../selectors/requests";
import { getDocumentPicker, getSelectionObjectID, getTodos, getViewDocumentModal } from "../selectors";

import PropTypes from "../../../../lib/prop-types";

class TemplateAssigning extends React.Component {
	static propTypes = {
		documentPicker: PropTypes.string,
		viewDocumentModal: PropTypes.string,
		getWorkflowTemplate: PropTypes.func.isRequired,
		removeTodo: PropTypes.func.isRequired,
		reorderTodos: PropTypes.func.isRequired,
		todoValueChange: PropTypes.func.isRequired,
		openDocumentPicker: PropTypes.func.isRequired,
		signatureStepChange: PropTypes.func.isRequired,
		attachDocumentToTodo: PropTypes.func.isRequired,
		closeDocumentPicker: PropTypes.func.isRequired,
		openEditSignatureTemplateModal: PropTypes.func.isRequired,
		closeSignatureTemplateEditor: PropTypes.func.isRequired,
		addTodoTemplate: PropTypes.func.isRequired,
		workflowIsRequesting: PropTypes.bool.isRequired,
		isDocumentSigningEnabled: PropTypes.bool.isRequired,
		appWidth: PropTypes.number.isRequired,
		workflowTodos: PropTypes.instanceOf(List).isRequired,
	};

	static defaultProps = {
		documentPicker: null,
		viewDocumentModal: null,
	};

	componentDidMount() {
		this.props.getWorkflowTemplate();
	}

	handleAddTodo = () => {
		this.handleGetActorActiveStatus(null);
		this.props.addTodoTemplate();
	};

	handleRemoveTodo = (todoID) => {
		this.props.removeTodo(todoID);
	};

	handleTodoChange = (value, name, index, todo) => {
		this.props.todoValueChange(value, name, index);
		this.handleGetActorActiveStatus(todo);
	};

	handleGetActorActiveStatus = (todo) => {
		if (!todo) {
			return true;
		}
		const jsonStringActor = JSON.stringify(todo.get("actor"));
		const actor = jsonStringActor ? JSON.parse(jsonStringActor) : null;
		return actor?.active;
	};
	handleGetActorName = (todo) => {
		const actor = JSON.parse(JSON.stringify(todo.get("actor")));
		return actor?.name || "";
	};

	handleReorderTodos = (...args) => {
		this.props.reorderTodos(...args);
	};

	handleOpenDocumentPicker = (todoID) => {
		this.props.openDocumentPicker(todoID);
	};

	handleDocumentPicker = (documentID) => {
		this.props.attachDocumentToTodo(documentID);
	};

	handleCloseDocumentPicker = () => {
		this.props.closeDocumentPicker();
	};

	handleOpenEditSignatureTemplateModal = (todoID) => {
		this.props.openEditSignatureTemplateModal(todoID);
	};

	handleCloseSignatureTemplateEditor = () => {
		this.props.closeSignatureTemplateEditor();
	};

	handleSignatureStepChange = (todoIndex, stepIndex, value) => {
		this.props.signatureStepChange(todoIndex, stepIndex, value);
	};

	render() {
		const { appWidth, workflowIsRequesting, workflowTodos, documentPicker, viewDocumentModal } = this.props;

		return (
			<section className="pb-[120px] pt-2.5" style={{ width: appWidth }}>
				<div className="mb-2.5 text-center text-xl font-bold uppercase leading-[30px] text-neutral-6">
					Workflow Todos
				</div>
				<div className="mx-auto max-w-[550px] text-[15px] font-light leading-5 text-neutral-5">
					Finalize the to-dos and signature requests for all employees that have been selected, confirming the
					actors and days to complete. Include any additional to-dos or remove any that you do not want to
					assign.
				</div>

				{workflowIsRequesting ? (
					<Spinner centered />
				) : (
					<div className="mt-[30px]">
						<div className="h-5">
							<div className="absolute left-[70px] top-0 h-5 text-[13px] font-semibold leading-5">
								To-Do
							</div>
							<div className="absolute right-[310px] top-0 h-5 text-[13px] font-semibold leading-5">
								Actor
							</div>
							<div className="absolute right-5 top-0 h-5 text-[13px] font-semibold leading-5">
								Days to Complete
							</div>
						</div>

						{workflowTodos.map((todo, ii) => {
							const actorActiveStatus = this.handleGetActorActiveStatus(todo);
							const actorName = this.handleGetActorName(todo);
							const componentProps = {
								documentSigning: todo.get("documentSigning"),
								onRemove: (todoID) => this.handleRemoveTodo(todoID),
								onChange: (value, name) => this.handleTodoChange(value, name, ii, todo),
								onOpenDocumentPicker: (documentID) => this.handleOpenDocumentPicker(documentID),
								onOpenViewDocument: (documentID) =>
									this.handleOpenEditSignatureTemplateModal(documentID),
								onSignatureStepChange: (stepIndex, value) =>
									this.handleSignatureStepChange(ii, stepIndex, value),
								id: todo.get("id"),
								label: todo.get("label"),
								actor: todo.get("actor"),
								actorName,
								actorActiveStatus,
								daysToComplete: todo.get("daysToComplete"),
							};

							return <Todo key={todo.get("id")} {...componentProps} />;
						})}

						<div
							onClick={this.handleAddTodo}
							className="mt-5 cursor-pointer rounded border-2 border-dashed border-neutral-2 bg-neutral-1 text-center text-[13px] font-semibold leading-[34px] text-neutral-5 hover:border-solid hover:border-primary-5 hover:bg-white hover:text-primary-5"
						>
							Add Todo
						</div>
					</div>
				)}

				{documentPicker ? (
					<DocumentPicker onClose={this.handleCloseDocumentPicker} onPick={this.handleDocumentPicker} />
				) : (
					<div />
				)}
				{viewDocumentModal ? (
					<EditSignatureTemplate
						todoID={viewDocumentModal}
						onClose={this.handleCloseSignatureTemplateEditor}
					/>
				) : (
					<div />
				)}
			</section>
		);
	}
}

const mapStateToProps = (state) => ({
	workflowTodos: getTodos(state),
	appWidth: getAppWidth(state) - 50,
	documentPicker: getDocumentPicker(state),
	appHeight: getAppHeight(state) - 150,
	selectionObjectID: getSelectionObjectID(state),
	viewDocumentModal: getViewDocumentModal(state),
	workflowIsRequesting: getIsRequesting(state, "WORKFLOWS:TEMPLATE.GET"),
});

const mapDispatchToProps = (dispatch) => ({
	addTodoTemplate: () => dispatch(addTodoTemplate()),
	closeDocumentPicker: () => dispatch(closeDocumentPicker()),
	removeTodo: (todoID) => dispatch(removeTodo(todoID)),
	getWorkflowTemplate: () => dispatch(fetchWorkflowTemplate()),
	reorderTodos: (...args) => dispatch(reorderTodos(...args)),
	closeSignatureTemplateEditor: () => dispatch(closeSignatureTemplateEditor()),
	todoValueChange: (...args) => dispatch(todoValueChange(...args)),
	openDocumentPicker: (...args) => dispatch(openDocumentPicker(...args)),
	signatureStepChange: (...args) => dispatch(changeSignatureStep(...args)),
	attachDocumentToTodo: (...args) => dispatch(attachDocumentToTodo(...args)),
	openEditSignatureTemplateModal: (todoID) => dispatch(openEditSignatureTemplateModal(todoID)),
});

export default connect(mapStateToProps, mapDispatchToProps)(TemplateAssigning);
